import styled from 'styled-components';

export const ToolbarStyled = styled.div`
    ${props => !props.forModal && !props.notStylized ? 'border-bottom: 1px solid #0095E8; padding-bottom: 20px' : ''}
`